/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountResponse } from './BankAccountResponse';
import {
    BankAccountResponseFromJSON,
    BankAccountResponseFromJSONTyped,
    BankAccountResponseToJSON,
    BankAccountResponseToJSONTyped,
} from './BankAccountResponse';

/**
 * Response for get financial channel
 * @export
 * @interface FinancialChannelResponse
 */
export interface FinancialChannelResponse {
    /**
     * Unique identifier of the financial channel
     * @type {number}
     * @memberof FinancialChannelResponse
     */
    id?: number;
    /**
     * The title of financial channel
     * @type {string}
     * @memberof FinancialChannelResponse
     */
    title?: string;
    /**
     * The type of financial channel
     * @type {string}
     * @memberof FinancialChannelResponse
     */
    type?: string;
    /**
     * Indicate if the financial channel is active
     * @type {boolean}
     * @memberof FinancialChannelResponse
     */
    active?: boolean;
    /**
     * 
     * @type {BankAccountResponse}
     * @memberof FinancialChannelResponse
     */
    bankAccounts?: BankAccountResponse;
}

/**
 * Check if a given object implements the FinancialChannelResponse interface.
 */
export function instanceOfFinancialChannelResponse(value: object): value is FinancialChannelResponse {
    return true;
}

export function FinancialChannelResponseFromJSON(json: any): FinancialChannelResponse {
    return FinancialChannelResponseFromJSONTyped(json, false);
}

export function FinancialChannelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialChannelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'active': json['active'] == null ? undefined : json['active'],
        'bankAccounts': json['bankAccounts'] == null ? undefined : BankAccountResponseFromJSON(json['bankAccounts']),
    };
}

export function FinancialChannelResponseToJSON(json: any): FinancialChannelResponse {
    return FinancialChannelResponseToJSONTyped(json, false);
}

export function FinancialChannelResponseToJSONTyped(value?: FinancialChannelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'type': value['type'],
        'active': value['active'],
        'bankAccounts': BankAccountResponseToJSON(value['bankAccounts']),
    };
}

